// extracted by mini-css-extract-plugin
export default {"wrapper":"sYVNKakIm6KvNkXeL1dg","buttonWrapper":"LOwjWO3pD6Zc5Fx__n1H","header":"ZX7NxMSNyQh44Mt8YkvT"};